












































































import {Component, Vue} from "vue-property-decorator";
import {MerchantCircle} from "@/entity/MerchantCircle";
import {MerchantCircleDto} from "@/dto/MerchantCircleDto";
import {getModule} from "vuex-module-decorators";
import {AuthStore} from "@/oauth/AuthStore";
import {CollectCompany} from "@/entity/CollectCompany";
import {CollectCompanyDto} from "@/dto/CollectCompanyDto";
import {SecurityUtils} from "@/oauth/SecurityUtils";
import {Validation} from "@/utils/Validation";
import {ajax} from "jquery";
import {UserInfoEntity} from "@/entity/UserInfoEntity";
import { CompanyInfo } from "@/entity/CompanyInfo";

@Component({
  components: {},
})

export default class AddComments extends Vue {

  SaveQTree = new MerchantCircle();
  ls = getModule(AuthStore);
  collectCompany = new CollectCompany()
  su = SecurityUtils;
  private Validation = Validation;
  loading= false
  disable= false

  chooseCompanyFlag = false;
  imageArray: string[] = [];

  closeImg(img: string) {
    for (let i = 0; i < this.imageArray.length; i++) {
      if (this.imageArray[i] === img) {
        this.imageArray.splice(i, 1);
      }
    }
  }

  handlerUpload(e: any) {
    const files = e.target.files[0] //当input中选择文件时触发一个事件并让data当中的files拿到所选择的文件
    const formData = new FormData();
    formData.append("file", files);
    formData.append("system", 'customer');
    const nf = this.$q.notify({type: 'ongoing', message: '正在处理...', timeout: 0});
    try {
      this.loading = true
      ajax({
        type: 'POST',
        url: "https://fileserver.yong-gang.cn/api/uploadFile",
        dataType: 'json',
        data: formData,
        processData: false,   // jQuery不要去处理发送的数据
        contentType: false,  // jQuery不要去设置Content-Type请求头
        //成功的回调
        success: (data: any) => {
          // console.log(data)
          // console.log(data.data.fileDownloadUrl);
          if (this.imageArray.length<9){
            this.imageArray.push(data.data.fileDownloadUrl);
            console.log('================')
            console.log(this.imageArray)
            nf({type: 'positive', message: '上传成功', timeout: 1500});
            this.loading = false
          }else {
            nf({type: 'positive', message: '最多只能选择9张', timeout: 1500});
            this.loading = false
          }

        },
        //超时时间
        timeout: 99999999,
        //失败的回调
        error: () => {
          // console.log('出错了')
          nf({type: 'positive', message: '上传失败', timeout: 1500});
          this.loading = false
        }
      })
    }catch (e) {
      nf({type: 'negative', message: '上传失败:' + e, timeout: 4000});
      this.loading = false
    }


  }

  handleButtonSelected() {
    if (this.$refs.selectFiles != null) {
      (this.$refs.selectFiles as any).click()
    }
  }

  uploadIt() {
    this.handleButtonSelected()
  }

  fanghui() {
    this.$router.push("keShangSelect1")
    // this.$router.go(-1)
  }


  handleUpload(e: { xhr: XMLHttpRequest }) {
    const url = e.xhr.responseText
    const url1 = url.replace("http", "https")
    const url2 = url1.replace("ygpubfile.yong-gang.cn:80", "ygpubfile.yong-gang.cn")

    this.imageArray.push(url2)
    // console.log(this.imageArray)
    // this.SaveQTree.imageCapture = url2;
  }

  async findAllCompanyName() {
    try {
      const id = this.su.getLoginUser().id as number;
      this.collectCompany = await CollectCompanyDto.findById(id)
      this.chooseCompanyFlag = true
    } catch (e) {
      this.chooseCompanyFlag = false
    }

  }

  async save() {
    if (this.SaveQTree.userMessage!==''){
      const nf = this.$q.notify({type: 'ongoing', message: '正在处理...', timeout: 0});
      try {
        this.loading = true
        this.disable = true
        this.chooseCompanyFlag = true
        if (this.chooseCompanyFlag == true) {
          this.SaveQTree.userId = this.ls.loginUser.username
          this.SaveQTree.userName = this.ls.loginUser.name
          // this.SaveQTree.userCompany = this.collectCompany.companyName

          /*
          const userInfoEntity = JSON.parse(localStorage.getItem("demo1") as any)
          let a = new UserInfoEntity()
          a  =userInfoEntity
          if (a.companyName != null){
            this.SaveQTree.userCompany = a.companyName
          }else {
            this.SaveQTree.userCompany = ''
          }
           */
          const companyInfo = JSON.parse(localStorage.getItem("selectedCompanyInfo") as any) as CompanyInfo;
          if (companyInfo.companyName != null){
            this.SaveQTree.userCompany = companyInfo.companyName
          }else {
            this.SaveQTree.userCompany = '默认系统组织'
          }

          this.SaveQTree.imageCapture = this.imageArray
          await MerchantCircleDto.saveNewComments(this.SaveQTree)
          nf({type: 'positive', message: '发送成功', timeout: 1500});
          this.loading = false;
          this.disable = false
          // this.$q.notify({message: '发送成功'});
          await this.$router.push({name: 'keShangSelect1'});
          this.imageArray = []
        } else {
          this.loading = false
          this.disable = false
          this.$q.notify({message: '请先选择公司后，再发表评论'});
        }
      }catch (e){
        this.loading = false;
        this.disable = false
        nf({type: 'negative', message: '发送失败:' + e, timeout: 4000});
      }
      // console.log(this.imageArray)

      // this.faTeiZiDialog = false;
      // this.getAll()
      // location.reload();
    }

  }

  private async mounted() {
    this.findAllCompanyName();
  }
}
